export default "__VITE_ASSET__ux3KsLaA__"